import classnames from 'classnames'

import { Icon } from '@paysense-india-services/elevate-web'

import useLayoutBreakpoints from '@/hooks/useLayoutBreakpoints'

import styles from './index.module.scss'

const Header = ({
  icon = {
    name: 'cross',
    fillColor: '#171717'
  },
  title,
  leftComponent: LeftComp,
  middleComponent: MidComp,
  rightComponent: RightComp,
  onLeftIconClick,
  customClass,
  hideOnDesktop = false,
  inShell = false,
  borderless = false
}) => {
  const { isSplitDesktop, isLoaded } = useLayoutBreakpoints()

  if (hideOnDesktop && (isSplitDesktop || !isLoaded)) {
    return null
  }

  let middleContent = null
  if (MidComp) {
    middleContent = <MidComp />
  } else if (title) {
    middleContent = <div className="ew-typography-normal ew-fw-semi-bold">{title}</div>
  }

  return (
    <>
      <div
        className={classnames(
          styles.headerContainer,
          inShell && styles.headerInShell,
          borderless && styles.headerBorderless,
          customClass,
          !inShell && 'ew-position-fixed',
          'ew-d-flex',
          'ew-align-items-center',
          'ew-justify-content-between',
          'ew-p-12',
          'ew-bg-primary',
          'ew-w-100'
        )}
      >
        <div className="ew-d-flex ew-align-items-center">
          <div
            className={classnames(styles.leftSection, 'ew-mr-8', 'ew-cursor-pointer')}
            onClick={onLeftIconClick}
            onKeyDown={event => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                onLeftIconClick?.()
              }
            }}
            role="button"
            tabIndex={0}
          >
            {LeftComp ? (
              <LeftComp />
            ) : (
              <Icon fill={icon.fillColor} id="header-nav-icon" name={icon.name} size={24} />
            )}
          </div>
          {middleContent}
        </div>
        {RightComp ? (
          <div className="ew-ml-8">
            <RightComp />
          </div>
        ) : null}
      </div>
      {!inShell ? <div className={styles.headerFiller} /> : null}
    </>
  )
}

export default Header
